import { NgZone } from '@angular/core';
import { AngularFireAnalytics } from '@angular/fire/analytics';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFireDatabase } from '@angular/fire/database';
import { environment } from '../../environments/environment';

export function AngularFirestoreDatabase(platformId: Object, zone: NgZone) {
  return new AngularFireDatabase(environment.firebase, 'protransport',
    environment.firebase.databaseURL, platformId, zone);
}

export function AngularFireAuthDatabase(platformId: Object, zone: NgZone) {
  return new AngularFireAuth(environment.firebase, 'protransport', platformId, zone);
}

export function AngularFirestoreAnalytics(platformId: Object, zone: NgZone) {
  return new AngularFireAnalytics(environment.firebaseAnalytics, 'carrierpro',
    true, null, '', false, null, platformId, zone);
}
